export default __webpack_public_path__ + "src/images/packages/maliba-lodge/12225fd304deff9410d0ecc70e68ded8-3.jpeg";